<shell-layout class="container-fatca" [error_identity]="true">
  <img class="m-auto" src="assets/img/errors/error_fatca_not_allowed.svg" alt="" />
  <ui-text color="blue-500" size="h4" weight="semibold" align="center" class="mt-6">
    <span class="only-desktop">
      Lo sentimos, no es posible continuar por este canal ya <br>
      que no se pudo completar la validación de la información <br> 
      solicitada.
    </span>
    <span class="only-mobile">
      Lo sentimos, no es posible <br>
      continuar por este canal ya que <br>
      no se pudo completar la <br>
      validación de la información <br> 
      solicitada.
    </span>
    
  </ui-text>
  <ui-text color="blue-500" align="center" class="mt-3">
    <span class="only-desktop">
      Para más información sobre cómo continuar la apertura 
      de tu cuenta, acércate a cualquiera de <br> nuestras agencias.
    </span>
    <span class="only-mobile">
      Para más información sobre cómo continuar la  
      apertura de tu cuenta, acércate a cualquiera de nuestras agencias.
    </span>
  </ui-text>
  <div class="flex justify-center mt-10">
    <ui-button
      class="btn-desktop only-desktop"
      (clicked)="closeModal()"
      type="primary"
      label="Entendido"
    ></ui-button>
    <ui-button
      class="btn-mobile only-mobile"
      (clicked)="closeModal()"
      type="primary"
      label="Entendido"
    ></ui-button>
  </div>
</shell-layout>
